import { render } from "./top-banner-toolbar.vue?vue&type=template&id=68a1d2dc&ts=true"
import script from "./top-banner-toolbar.vue?vue&type=script&lang=ts"
export * from "./top-banner-toolbar.vue?vue&type=script&lang=ts"

import "./top-banner-toolbar.vue?vue&type=style&index=0&id=68a1d2dc&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__